import { Route } from 'react-router-dom'

function ReportRoute({ component: C, ...routeProps }) {
  return <Route {...routeProps} render={props => <C {...props} />} />
}

export default ReportRoute
